import { render, staticRenderFns } from "./PlaceItemDetails.vue?vue&type=template&id=5c435ccf&scoped=true&"
import script from "./PlaceItemDetails.vue?vue&type=script&lang=ts&"
export * from "./PlaceItemDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PlaceItemDetails.vue?vue&type=style&index=0&id=5c435ccf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c435ccf",
  null
  
)

export default component.exports